import { Center } from '@mantine/core';
import { EmptyState } from '@repo/common/components';

export function RootAuthRedirect() {
	return (
		<Center h="100vh">
			<EmptyState
				title="Authentication issue"
				description="Redirecting to login page..."
				size="lg"
				loading={true}
				includeGoBack={false}
			/>
		</Center>
	);
}
